export const DEFAULT_LANG = 'en'

export const LOCALES = ['en', 'it']
export const LOCKED_PERSONAL_AREA = process.env.NEXT_PUBLIC_LOCKED_PERSONAL_AREA

export const PERSONAL_AREA_NAME = 'mycompetition'
export const PROTECTED_ROUTES = [`/${PERSONAL_AREA_NAME}`, '/apply']

const AUTH_PREFIX = '/auth'

export const AUTH_ROUTES = {
  prefix: AUTH_PREFIX,
  login: `${AUTH_PREFIX}/login`,
  logout: `${AUTH_PREFIX}/logout?post_logout_redirect_uri=${process.env.NEXT_PUBLIC_BASE_URL}`,
}

// Important!!
// To be updated when new API routes
// are added or removed on BE side
const API_PREFIX = '/api'

export const API_ROUTES = {
  prefix: API_PREFIX,
  user: `${API_PREFIX}/user`,
  me: `${API_PREFIX}/user/me`,
  capabilities: `${API_PREFIX}/user/me/capabilities`,
  applications: `${API_PREFIX}/user/me/entries`,
  draft: `${API_PREFIX}/user/me/entry/draft`,
  notifications: `${API_PREFIX}/user/me/notifications`,
  notificationsUnread: `${API_PREFIX}/user/me/notifications/unread`,
  notificationsRead: `${API_PREFIX}/user/me/notifications/read`,
  saveNewApplication: `${API_PREFIX}/user/me/entry/save`,
  saveApplication: `${API_PREFIX}/user/me/entry/{applicationId}/save`,
  getCurrentApplication: `${API_PREFIX}/user/me/entry/{applicationId}`,
  getValidOpportunity: `${API_PREFIX}/user/me/opportunity/unlinked/{type}/{competitionId}`,
  getCompetition: `${API_PREFIX}/competition/{slug}`,
  getApplication: `${API_PREFIX}/application/{slug}`,
  document: `${API_PREFIX}/user/me/entry/{applicationId}/document`,
  schools: `${API_PREFIX}/school`,
  linkOpportunity: `${API_PREFIX}/user/me/opportunity/link/{campaignId}`,
  documentFields: `${API_PREFIX}/user/me/entry/{applicationId}/document-fields`,
  submitApplication: `${API_PREFIX}/user/me/entry/{applicationId}/submit`,
}

export const CONTENT_API_ROUTES = {
  homepage: `${API_PREFIX}/site/pages/homepage`,
  homepageIt: `${API_PREFIX}/site/pages/homepage-it`,
  competitions: `${API_PREFIX}/site/competitions`,
  applications: `${API_PREFIX}/site/applications`,
  getPages: `${API_PREFIX}/site/competitions?archived=true`,
  getPublicPage: `${API_PREFIX}/site/pages/{slug}`,
  configuration: `${API_PREFIX}/site/configuration`,
}

export const NABADOMAIN = 'https://www.naba.it' as const

export const DEFAULT_METADATA = {
  title: ' NABA Admissions Website | Apply online at NABA',
  siteName: 'NABA Admissions Website',
}

export const APPLY_LINK_SOURCE = {
  competition: 'Click Apply Now Competition Hero',
  competitionSidebar: 'Click Apply Now Competition Bottom',
  cardList: 'Click Apply Home',
}
